import { __assign, __extends } from "tslib";
// DS: I38
import React from 'react';
import IconWrap from '../IconWrap';
var XTimes = /** @class */ (function (_super) {
    __extends(XTimes, _super);
    function XTimes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    XTimes.prototype.render = function () {
        return (React.createElement(IconWrap, __assign({}, this.props),
            React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
                React.createElement("g", null,
                    React.createElement("path", { d: "M14.8284271,12 L20.4852814,17.6568542 L17.6568542,20.4852814 L12,14.8284271 L6.34314575,20.4852814 L3.51471863,17.6568542 L9.17157288,12 L3.51471863,6.34314575 L6.34314575,3.51471863 L12,9.17157288 L17.6568542,3.51471863 L20.4852814,6.34314575 L14.8284271,12 Z" })))));
    };
    return XTimes;
}(React.Component));
export { XTimes };
export default XTimes;
//# sourceMappingURL=XTimes.js.map